import { createStore } from "@stencil/store";
import {
    UserSettingsHandler,
    IUserSettings,
    ICategories,
} from "@trumpf/notifies.user-settings-handler";

export const state = createStore<{
    userSettings: IUserSettings;
    categories: ICategories;
    token: string | null;
    error: string | null;
    loading: boolean;
    unsavedChanges: boolean;
    saved: boolean;
}>({
    userSettings: null,
    categories: null,
    token: null,
    error: null,
    loading: true,
    unsavedChanges: false,
    saved: false,
});

const userSettingsHandler = new UserSettingsHandler();

export function getUserSettings(
    token: string,
    locale: string,
    version: string,
    env: number,
    onDone?: () => void
) {
    state.set("loading", true);
    getCategories(token, locale, version, env, () => {
        userSettingsHandler.getUserSettings(
            token,
            (receivedUserSettings: IUserSettings) => {
                state.set("userSettings", receivedUserSettings);
                state.set("loading", false);

                if (onDone) {
                    onDone();
                }
            },
            async (response: Response) => {
                state.set("loading", false);
                state.set("error", `Error with status ${response.status}`);
            },
            version,
            env // optional stage parameter
        );
    });
}

export function getCategories(
    token: string,
    locale: string,
    version: string,
    env: number,
    onDone?: () => void
) {
    userSettingsHandler.getCategories(
        token,
        version,
        locale,
        (receivedCategories: ICategories) => {
            state.set("categories", receivedCategories);
            if (onDone) {
                onDone();
            }
        },
        async (response: Response) => {
            state.set("loading", false);
            state.set("error", `Error with status ${response.status}`);
        },
        env // optional stage parameter
    );
}

export function sendUserSettings(
    token: string,
    version: string,
    setting: IUserSettings,
    env: number,
    onDone?: () => void
) {
    state.set("loading", true);
    userSettingsHandler
        .createUserSetting(token, version, setting, env)
        .then((response) => {
            state.set("loading", false);

            if (!response.ok) {
                throw new Error(`Error with status ${response.status}`);
            }

            state.set("unsavedChanges", false);
            state.set("saved", true);

            setTimeout(() => {
                state.set("saved", false);
            }, 3000);

            if (onDone) {
                onDone();
            }
        })
        .catch((err) => {
            state.set("loading", false);
            state.set("error", err.message);
        });
}
